type Recommendation = {
  name: string;
  role: string;
  quote: string;
};

export const RECOMMENDATIONS: Recommendation[] = [
  {
    name: "William Tinney",
    role: "CTO @ Greenpixie",
    quote:
      "Alex was a 10/10 contractor with everything from communication to quality of work being exceptional. He has shown excellent technical knowledge, providing valuable insights into the project and has worked through the job ahead of schedule. I would 100% recommend him and will work with him again in the future.",
  },
  {
    name: "Jonathan Woolf",
    role: "Founder @ JoWoCo",
    quote:
      "Alexander was fantastic. He went above and beyond on this assignment and seems to have a thorough knowledge of React Native",
  },
  {
    name: "Bojan Kalinic",
    role: "CEO @ Iris Solutions",
    quote:
      "Alexander was great and did his part exceptionally. Followed the timelines and the deadline. Although it was a small work he showed his skills to be up to par. I will definitely work him again for a similar project",
  },
];
